var map = {
	"./baby_changing.svg": 113,
	"./buggy_park.svg": 114,
	"./cafe.svg": 115,
	"./cloakroom.svg": 116,
	"./disabled_toilet.svg": 117,
	"./discovery_area.svg": 118,
	"./entrance.svg": 119,
	"./exits.svg": 120,
	"./female_toilet.svg": 121,
	"./garden.svg": 122,
	"./gender_neutral_toilet.svg": 123,
	"./information.svg": 124,
	"./lifts.svg": 125,
	"./male_toilet.svg": 126,
	"./sanitation.svg": 127,
	"./shop.svg": 128,
	"./stairs.svg": 129,
	"./steps.svg": 130,
	"./study_area.svg": 131,
	"./tickets.svg": 132,
	"./trail_marker.svg": 43,
	"./you_are_here.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;